import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
  useUtc: true
};

const VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => YearPickerComponent),
  multi: true
};

@Component({
  selector: 'Teranet-YearPicker',
  templateUrl: './year-picker.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

    VALUE_ACCESSOR
  ],
  encapsulation: ViewEncapsulation.None,
})
export class YearPickerComponent implements OnInit {
  @Input() classCss: string;
  @Input() disabled: boolean = false;
  @Input() error: string = '';
  @Input() label: string;
  @Input() required: boolean = false;
  private dateValue: Date;

  ngOnInit() { }

  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.writeValue(normalizedYear.format('YYYY'));
    datepicker.close();
  }

  onChange = (_) => { };

  onTouched = () => { };

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }

  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  // write the value to the input
  writeValue(value: any) {
    this.dateValue = value;
    this.onChange(value);
  }
  // get value for component from private variable
  get value(): any { return this.dateValue; };
  // set the value (emit) to the parent model
  set value(value: any) {
    if (value !== this.dateValue) {
      this.dateValue = value;
      this.onChange(value);
    }
  }
}
